import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Zap } from 'lucide-react';
export function TruthSection() {
  return <section className="w-full bg-[#1B2A4A] text-[#FDF8F0] px-4 py-16 md:py-24" data-id="element-162">
      <div className="max-w-3xl mx-auto" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-164">
          <h2 className="text-3xl md:text-5xl font-bold text-[#FDF8F0] mb-8 font-serif text-center" data-id="element-165">
            Aquí va la verdad que cambia todo
          </h2>

          <p className="text-xl text-[#FDF8F0]/90 mb-8 text-center max-w-2xl mx-auto" data-id="element-166">
            Tu hijo no pelea por la pantalla porque sea “malo”. Pelea porque la
            pantalla está haciendo un trabajo que su cuerpo todavía no sabe
            hacer:
          </p>

          <div className="text-center mb-12" data-id="element-167">
            <span className="inline-block text-4xl md:text-6xl font-bold text-[#C4704B] font-serif tracking-wide uppercase border-b-4 border-[#C4704B] pb-2" data-id="element-168">
              Regularse
            </span>
          </div>

          <p className="text-lg text-[#FDF8F0]/80 mb-8 text-center" data-id="element-169">
            Y si tú solo quitas la pantalla sin reemplazo...
          </p>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-170">
            {/* Child's Experience */}
            <div className="bg-[#FDF8F0]/10 p-6 rounded-xl backdrop-blur-sm border border-[#FDF8F0]/20" data-id="element-171">
              <div className="flex items-center mb-4" data-id="element-172">
                <Brain className="h-6 w-6 text-[#C4704B] mr-2" data-id="element-173" />
                <h3 className="text-xl font-bold text-[#FDF8F0]" data-id="element-174">
                  El niño se queda con:
                </h3>
              </div>
              <ul className="space-y-3 text-[#FDF8F0]/90" data-id="element-175">
                <li className="flex items-center" data-id="element-176">• Frustración</li>
                <li className="flex items-center" data-id="element-177">• Aburrimiento</li>
                <li className="flex items-center" data-id="element-178">• Ansiedad de transición</li>
                <li className="flex items-center" data-id="element-179">• Energía acumulada</li>
              </ul>
            </div>

            {/* Parent's Experience */}
            <div className="bg-[#FDF8F0]/10 p-6 rounded-xl backdrop-blur-sm border border-[#FDF8F0]/20" data-id="element-180">
              <div className="flex items-center mb-4" data-id="element-181">
                <Zap className="h-6 w-6 text-[#C4704B] mr-2" data-id="element-182" />
                <h3 className="text-xl font-bold text-[#FDF8F0]" data-id="element-183">
                  Tú te quedas con:
                </h3>
              </div>
              <ul className="space-y-3 text-[#FDF8F0]/90" data-id="element-184">
                <li className="flex items-center" data-id="element-185">• Ruido</li>
                <li className="flex items-center" data-id="element-186">• Culpa</li>
                <li className="flex items-center" data-id="element-187">• Caos</li>
                <li className="flex items-center" data-id="element-188">• Y cero herramientas</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}